// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vue-codemirror[data-v-81d2133a] {\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
